import type { TemplatePage } from "./builder";
import { LINKEDIN } from "./sets/linkedin";
import { MOCKUP_TEMPLATES } from "./sets/mockups";
import { POSTS } from "./sets/posts";
import { PRINT } from "./sets/print";
import { REEL_MOCKUPS } from "./sets/reel-mockups";
import { REELS } from "./sets/reels";
import { MORE_REELS_2 } from "./sets/reels-more";
import { SHOWCASE } from "./sets/showcase";
import { SPEAKER_REELS } from "./sets/speaker-reels";
import { STORIES } from "./sets/stories";
import { WIDE_VIDEOS } from "./sets/videos";

/**
 * The built-in template library (docs/06-brand-kit.md). Every organization
 * has it from the start. Coordinates refer to a 1080 px wide page; colours
 * and text styles are brand roles, so each template takes on the kit of the
 * project (or its own design style while there is no kit). The templates
 * live in `./sets`, one file per group.
 */

export const TEMPLATE_TOPICS = [
  "ankuendigung",
  "event",
  "angebot",
  "zitat",
  "wissen",
  "team",
  "produkt",
  "community",
] as const;
export type TemplateTopic = (typeof TEMPLATE_TOPICS)[number];

export const TEMPLATE_TOPIC_LABELS: Record<TemplateTopic, string> = {
  ankuendigung: "Neuigkeiten",
  event: "Veranstaltung",
  angebot: "Angebot & Aktion",
  zitat: "Zitat",
  wissen: "Tipps & Wissen",
  team: "Team & Jobs",
  produkt: "Produkt & Leistung",
  community: "Community",
};

export interface LibraryTemplate {
  id: string;
  title: string;
  description: string;
  presetId: string;
  topic: TemplateTopic;
  /** Design style (`BRAND_STYLES`) used while the organization has no kit. */
  style: string;
  /** Extra search words (German, lower case), e.g. "rezept" or "makler". */
  tags?: string[];
  /**
   * Video templates: moment (ms) the still preview shows, for templates
   * whose main elements appear later (numbered tips, chapters).
   */
  previewTime?: number;
  pages: TemplatePage[];
}

export const LIBRARY_TEMPLATES: readonly LibraryTemplate[] = [
  ...POSTS,
  ...STORIES,
  ...LINKEDIN,
  ...PRINT,
  ...REELS,
  ...MORE_REELS_2,
  ...REEL_MOCKUPS,
  ...SPEAKER_REELS,
  ...WIDE_VIDEOS,
  ...MOCKUP_TEMPLATES,
  ...SHOWCASE,
];
